module.exports = __webpack_public_path__ + "img/success-icon.6a14e787.svg";